<template>
  <div v-if="showAlert" class="alert alert-dismissible alert-danger">
    <span @click="showAlert = !showAlert" style="cursor : pointer;">❌ </span>
    You need to enter a search term!
  </div>
  <div id="search" class="card card-body bg-light mb-2">
    <h4>Search Reddit</h4>
    <form id="search-form">
      <div class="form-group">
        <input
          v-model="searchInput"
          type="text"
          id="search-input"
          class="form-control mb-3"
          placeholder="Search Term..."
        />
      </div>
      Sort By:
      <div class="form-check form-check-inline">
        <input
          v-model="sort"
          class="form-check-input ml-2"
          type="radio"
          name="sortby"
          value="relevance"
          checked
        />
        <label class="form-check-label"> Relevance </label>
      </div>
      <div class="form-check form-check-inline">
        <input
          v-model="sort"
          class="form-check-input"
          type="radio"
          name="sortby"
          value="new"
        />
        <label class="form-check-label"> Latest </label>
      </div>
      <h5 class="mt-2">Limit:</h5>
      <div class="form-group">
        <select v-model="limit" name="limit" id="limit" class="form-control">
          <option value="5">5</option>
          <option value="10">10</option>
          <option value="25" selected>25</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
      </div>
      <button
        @click.prevent="handleSubmit"
        type="submit"
        class="btn btn-dark mt-4"
      >
        Search
      </button>
    </form>
  </div>
</template>

<script>
export default {
  name: "Searchbox",
  props: {
    inSearch: String,
    inSort: {
      validator: function(value) {
        // The value must match one of these strings
        return ['relevance', 'new'].indexOf(value) !== -1
      }
    },
    inLimit: {
      validator: function(value) {
        // The value must match one of these strings
        return ['5', '10', '25','100'].indexOf(value) !== -1
      }
    },
  },
  data() {
    return {
      searchInput: this.inSearch ? this.inSearch : "",
      sort: this.inSort ? this.inSort : "relevance",
      limit: this.inLimit ? this.inLimit : "25",
      showAlert: false,
    };
  },
  methods: {
    handleSubmit() {
      //console.log(this.searchInput, this.sort, this.limit);
      if (!this.searchInput) {
        this.showAlert = true;
      } else {
        this.$emit("search", this.searchInput, this.sort, this.limit);
      }
    },
  },
  emits: ["search"]
};
</script>

<style>
</style>